// extracted by mini-css-extract-plugin
export default {"tooltip":"fn-z","sharingV2":"gn-z","sharingIconsV2":"hn-z","links":"in-z","link":"jn-z","facebookV2":"kn-z","twitterV2":"ln-z","pinterestV2":"mn-z"};